// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules_dev/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pi-predicate{position:absolute}.pi-predicate.dragged,.pi-predicate.dragged:active,.pi-predicate.dragged:hover{color:#fff!important;background-color:#007bff!important;border-color:#007bff!important}.pi-predicate:active,.pi-predicate:hover{background-color:transparent!important;border-color:#007bff!important;color:#007bff!important;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
